module.exports = __webpack_public_path__ + "img/SES_140254101.b59a5639.jpg";